export const GET_LIST_OF_VEHICLES = "GET_LIST_OF_VEHICLES";
export const VEHICLE_LIST_FETCH_ERROR = "VEHICLE_LIST_FETCH_ERROR";
